import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdesaoService } from 'src/app/services/adesao.service';
import { AutenticacaoService } from 'src/app/services/autenticacao.service';
import { MovimentacoesPartService } from 'src/app/services/movimentacoes-part.service';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormControl } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { DatePipe } from "@angular/common";
import { CurrencyPipe } from '@angular/common';
import { DecimalPipe } from '@angular/common';
import { CommonModule } from '@angular/common';
declare var $: any;

@Component({
    selector: 'app-moves',
    templateUrl: './moves.component.html',
    styleUrls: ['./moves.component.css'],
    imports: [CommonModule, ReactiveFormsModule, NgxPaginationModule, DatePipe, CurrencyPipe, DecimalPipe]
})
export class MovesComponent implements OnInit {

  loading: boolean = false;
  dataAtaul: Date;
  
  listStatusMov: any[] = [];
  listPrimeiroAnoMes: any[] = [];
  listUltimoAnoMes: any[] = [];  
  tiposFundos: any[] = [];

  formFiltro: FormGroup = null;
  paginaAtual : number = 1 ;
  qntPorPage : number = 10;

  movimentacoes: any[] = [];

  itemSelecionado: any = null;
  dadosBoleto: any = null;

  constructor(private router: Router, private adesao: AdesaoService, private autenticacao: AutenticacaoService, private movimentacoesPart: MovimentacoesPartService, private toastr: ToastrService) {

    this.formFiltro = new FormGroup({
      movStatus: new FormControl(''),
      anomesInicio: new FormControl(0),
      anomesFim: new FormControl(0),
      tipoFundo: new FormControl(0),
      tipoOrdem: new FormControl(0),
    });

   }

  ngOnInit() {
    this.listar();
    this.listarFiltros();
  }
  

  listar(){

    this.loading = true;

    this.movimentacoesPart
        .listar(this.formFiltro.getRawValue())
        .pipe(
          finalize(() => this.loading=false)
        )
        .subscribe(
          (res: any[]) => {
            
            this.movimentacoes = res; 

            this.movimentacoes.forEach(function (x) {
              x.loadingBoleto = false;
            });
    
            this.setaStatus();           
          }
        )
  }

  listarFiltros(){

    this.movimentacoesPart
        .listarFiltros()
        .subscribe(
          (res:any)=>{
            this.listStatusMov = res.status,
            this.listPrimeiroAnoMes = res.anos;
            this.listUltimoAnoMes = res.anos;
            this.tiposFundos = res.tipos;
          }
        )
  }


  setaStatus(){
    let dataAtual = new Date();
    this.movimentacoes.forEach(item => {
      let datavenc = new Date(item.DTA_VENC.replace(/-/g, '\/'));

      if(new Date(datavenc) < (dataAtual) && item.DTA_PGTO === null ){

        item.STATUS = "Pendente";  
        item.CLASSE = "status red"

      }else if(item.DTA_PGTO !== null){

        item.STATUS =  "Pago"
        item.CLASSE = "status gray"
       
      }else{

        item.STATUS =  "A vencer"
        item.CLASSE = "status blue"
       
      }      
    });
  }

  print() {
    window.print();
  }

}
